import { render, staticRenderFns } from "./karzdoron.vue?vue&type=template&id=2f624638&scoped=true&"
import script from "./karzdoron.vue?vue&type=script&lang=js&"
export * from "./karzdoron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f624638",
  null
  
)

export default component.exports